import React, { useEffect, useState } from 'react';

const ExerciseChrono = (props) => {
  const [diff, setDiff] = useState(null);
  const [initial, setInitial] = useState(null);
  const [startChrono, setStartChrono] = useState(false);

  useEffect(() => {
    start();
  }, []);

  // const tick = () => {
  //   const update = new Date(+new Date() - initial);
  //   setDiff(update);
  // };

  const start = () => {
    if (!startChrono) {
      setInitial(+new Date());
      setStartChrono(true);
    }
    if (startChrono) setStartChrono(false);
  };

  // useEffect(() => {
  //   if (initial && startChrono && props.startExercise) {
  //     tick();
  //   }
  // }, [initial]);

  // useEffect(() => {
  //   if (diff && startChrono) {
  //     tick();
  //   }
  //   props.handleExerciseTime(diff);
  // }, [diff]);

  useEffect(() => {
    let timer;
    if (startChrono) {
      timer = setInterval(() => {
        setDiff(Date.now() - initial);
      }, 100); // o 1000ms si sólo quieres precisión de segundos
    }
    return () => clearInterval(timer);
  }, [startChrono, initial]);

  const timeFormat = (date) => {
    if (!date) return '00:00';

    const mm = Math.floor(diff / 60000)
      .toString()
      .padStart(2, '0');
    const ss = Math.floor((diff % 60000) / 1000)
      .toString()
      .padStart(2, '0');

    props.handleExerciseTime(`${mm}:${ss}`);
    return `${mm}:${ss}`;
  };

  return (
    <span className='App' onClick={start}>
      {timeFormat(diff)}
    </span>
  );
};

export default ExerciseChrono;
